import { useEffect, useRef } from "react";

const INACTIVITY_TIMEOUT = 60 * 60 * 1000; // 60 minutes

export const useLogout = (logoutCallback, isLoggedIn) => {
  const timeoutIdRef = useRef(null);

  const resetTimer = () => {
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }
    if (isLoggedIn) {
      timeoutIdRef.current = setTimeout(logoutCallback, INACTIVITY_TIMEOUT);
    }
  };

  useEffect(() => {
    if (!isLoggedIn) return;

    const activityEvents = [
      "mousemove",
      "keydown",
      "scroll",
      "touchstart",
      "click",
    ];

    activityEvents.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer();

    return () => {
      activityEvents.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }
    };
  }, [logoutCallback, isLoggedIn]);
};
